// src/pages/CaseStudies.jsx
import { Link } from 'react-router-dom';
import { caseStudies } from '../models/caseStudiesData';

export default function CaseStudies() {
  return (
    <section className="section" id="case-studies">
      {/* Hidden anchor for scrolling */}
      <span id="casestudies" className="block relative -top-24 invisible"></span>
      <div className="container text-center">
        <p className="section-subtitle">Deep Dives ?</p>
        <h6 className="section-title mb-6">Case Studies</h6>

        {/* Case Study Cards Container - matches Publications clean style without image or tags */}
        <div className="max-w-4xl mx-auto space-y-6 text-left">
          {caseStudies.map((cs) => (
            <div key={cs.id} className="blog-card">
              <div className="blog-card-body w-full">
                <h5 className="blog-card-title">{cs.title}</h5>

                <div className="blog-card-caption">
                  <span>By: {cs.developer}</span>
                  <span>
                    <i className="ti-bookmark text-primary mr-1"></i> {cs.category}
                  </span>
                  <span>
                    <i className="ti-calendar text-primary mr-1"></i> {cs.date}
                  </span>
                </div>

                <p className="text-gray-600 dark:text-gray-300 text-sm mb-4 leading-relaxed">
                  {cs.description}
                </p>

                <Link
                  to={`/case-study/${cs.slug}`}
                  className="blog-card-link"
                >
                  Read Case Study <i className="ti-angle-double-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
